import bed from '../../assets/images/icons/Bed';
import calendar from '../../assets/images/icons/Calendar';
import chat from '../../assets/images/icons/Chat';
import checkEvolution from '../../assets/images/icons/CheckEvolution';
import chevronLeft from '../../assets/images/icons/ChevronLeft';
import chevronRight from '../../assets/images/icons/ChevronRight';
import closeEvolution from '../../assets/images/icons/CloseEvolution';
import comment from '../../assets/images/icons/Comment';
import curvedArrow from '../../assets/images/icons/CurvedArrow';
import dislike from '../../assets/images/icons/Dislike';
import download from '../../assets/images/icons/Download';
import eye2 from '../../assets/images/icons/Eye2';
import folder from '../../assets/images/icons/Folder';
import instagram from '../../assets/images/icons/Instagram';
import legendLineIcon from '../../assets/images/icons/LegendLineIcon';
import like from '../../assets/images/icons/Like';
import linkContainer from '../../assets/images/icons/LinkContainer';
import linkedin from '../../assets/images/icons/Linkedin';
import lock from '../../assets/images/icons/Lock';
import logoBig from '../../assets/images/icons/LogoBig';
import logoWhite from '../../assets/images/icons/LogoWhite';
import openOutside from '../../assets/images/icons/OpenOutside';
import reload from '../../assets/images/icons/Reload';
import save from '../../assets/images/icons/Save';
import shareResize from '../../assets/images/icons/ShareResize';
import SvgAlertAgenda from '../../assets/images/icons/AlertAgenda';
import SvgAlertTriangle from '../../assets/images/icons/AlertTriangle';
import SvgArrowBottom from '../../assets/images/icons/ArrowBottom';
import SvgArrowFullLeft from '../../assets/images/icons/ArrowFullLeft';
import SvgArrowFullRight from '../../assets/images/icons/ArrowFullRight';
import SvgArrowRight from '../../assets/images/icons/ArrowRight';
import SvgArrowTop from '../../assets/images/icons/ArrowTop';
import SvgCheck from '../../assets/images/icons/Check';
import SvgClearFilters from '../../assets/images/icons/ClearFilter';
import SvgClose from '../../assets/images/icons/Close';
import SvgComments from '../../assets/images/icons/Comments';
import SvgDownEvolution from '../../assets/images/icons/DownEvolution';
import SvgDropdown from '../../assets/images/icons/Dropdown';
import SvgExport from '../../assets/images/icons/Export';
import SvgEye from '../../assets/images/icons/Eye';
import SvgEyeClosed from '../../assets/images/icons/EyeClosed';
import SvgFacebook from '../../assets/images/icons/Facebook';
import SvgIconCommunication from '../../assets/images/icons/Communication';
import SvgIconDistrib from '../../assets/images/icons/Distrib';
import SvgIconEspace from '../../assets/images/icons/IconEspace';
import SvgIconEuro from '../../assets/images/icons/Euro';
import SvgIconExit from '../../assets/images/icons/Exit';
import SvgIconHelper from '../../assets/images/icons/IconHelper';
import SvgIconHome from '../../assets/images/icons/Home';
import SvgIconLogoMedium from '../../assets/images/icons/IconLogoMedium';
import SvgIconLogoSmall from '../../assets/images/icons/IconLogoSmall';
import SvgIconMenu from '../../assets/images/icons/IconMenu';
import SvgLoadingArrow from '../../assets/images/icons/LoadingArrow';
import SvgLocalisationContainer from '../../assets/images/icons/LocalisationContainer';
import SvgLogo from '../../assets/images/icons/Logo';
import SvgLogoCustom from '../../assets/images/icons/LogoCustom';
import SvgMagnifyingGlass from '../../assets/images/icons/MagnifyingGlass';
import SvgNegativeEvolution from '../../assets/images/icons/NegativeEvolution';
import SvgNeutralEvolution from '../../assets/images/icons/NeutralEvolution';
import SvgNotification from '../../assets/images/icons/Notification';
import SvgOpenLink from '../../assets/images/icons/OpenLink';
import SvgPdf from '../../assets/images/icons/Pdf';
import SvgPhone from '../../assets/images/icons/Tel';
import SvgPhoneAlt from '../../assets/images/icons/Phone';
import SvgPlus from '../../assets/images/icons/Plus';
import SvgPositiveEvolution from '../../assets/images/icons/PositiveEvolution';
import SvgSettings from '../../assets/images/icons/Settings';
import SvgShare from '../../assets/images/icons/Share';
import SvgShowLocalisation from '../../assets/images/icons/ShowLocalisation';
import SvgSort from '../../assets/images/icons/Sort';
import SvgStar from '../../assets/images/icons/Star';
import SvgStarsCheck from '../../assets/images/icons/StarsCheck';
import SvgTag from '../../assets/images/icons/Tag';
import SvgTooltip from '../../assets/images/icons/Tooltip';
import SvgTranslate from '../../assets/images/icons/Translate';
import SvgTravel from '../../assets/images/icons/Travel';
import SvgTwitter from '../../assets/images/icons/Twitter';
import SvgUpEvolution from '../../assets/images/icons/UpEvolution';
import SvgWorld from '../../assets/images/icons/World';
import threeDot from '../../assets/images/icons/ThreeDot';
import Globe from '../../assets/images/icons/Globe';
import Stats from '../../assets/images/icons/Stats';
import MichelinGreenStarIcon from '../../assets/images/icons/MichelinGreenStarIcon';
import MichelinStarIcon from '../../assets/images/icons/MichelinStarIcon';
import RssIcon from '../../assets/images/icons/RssIcon';

export default {
  'logo-medium': SvgIconLogoMedium(),
  'logo-small': SvgIconLogoSmall(),
  'phone-alt': SvgPhoneAlt(),
  agenda: SvgAlertAgenda(),
  alert: SvgAlertTriangle(),
  arrowBottom: SvgArrowBottom(),
  arrowFullLeft: SvgArrowFullLeft(),
  arrowFullRight: SvgArrowFullRight(),
  arrowRight: SvgArrowRight(),
  arrowTop: SvgArrowTop(),
  bed: bed(),
  calendar: calendar(),
  chat: chat(),
  check: SvgCheck(),
  checkEvolution: checkEvolution(),
  chevronLeft: chevronLeft(),
  chevronRight: chevronRight(),
  close: SvgClose(),
  clearFilters: SvgClearFilters(),
  closeEvolution: closeEvolution(),
  comment: comment(),
  comments: SvgComments(),
  communication: SvgIconCommunication(),
  curvedArrow: curvedArrow(),
  dislike: dislike(),
  distrib: SvgIconDistrib(),
  downEvolution: SvgDownEvolution(),
  download: download(),
  dropdown: SvgDropdown(),
  espace: SvgIconEspace(),
  euro: SvgIconEuro(),
  exit: SvgIconExit(),
  export: SvgExport(),
  eye2: eye2(),
  eye: SvgEye(),
  eyeClosed: SvgEyeClosed(),
  facebook: SvgFacebook(),
  folder: folder(),
  helper: SvgIconHelper(),
  home: SvgIconHome(),
  instagram: instagram(),
  legendLineIcon: legendLineIcon(),
  like: like(),
  linkContainer: linkContainer(),
  linkedin: linkedin(),
  loadingArrow: SvgLoadingArrow(),
  localisationContainer: SvgLocalisationContainer(),
  lock: lock(),
  logo: SvgLogo(),
  logoBig: logoBig(),
  logoCustom: SvgLogoCustom(),
  logoWhite: logoWhite(),
  magnifyingGlass: SvgMagnifyingGlass(),
  menuMobile: SvgIconMenu(),
  negativeEvolution: SvgNegativeEvolution(),
  neutralEvolution: SvgNeutralEvolution(),
  notification: SvgNotification(),
  openLink: SvgOpenLink(),
  openOutside: openOutside(),
  pdf: SvgPdf(),
  phone: SvgPhone(),
  plus: SvgPlus(),
  positiveEvolution: SvgPositiveEvolution(),
  reload: reload(),
  save: save(),
  settings: SvgSettings(),
  share: SvgShare(),
  shareResize: shareResize(),
  showLocalisation: SvgShowLocalisation(),
  sort: SvgSort(),
  star: SvgStar(),
  starsCheck: SvgStarsCheck(),
  tag: SvgTag(),
  threeDot: threeDot(),
  tooltip: SvgTooltip(),
  translate: SvgTranslate(),
  travel: SvgTravel(),
  twitter: SvgTwitter(),
  upEvolution: SvgUpEvolution(),
  world: SvgWorld(),
  globe: Globe(),
  stats: Stats(),
  michelinStarIcon: MichelinStarIcon(),
  michelinGreenStarIcon: MichelinGreenStarIcon(),
  rssIcon: RssIcon()
};
